import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=676a7f44&scoped=true"
import script from "./OrderRow.vue?vue&type=script&lang=js"
export * from "./OrderRow.vue?vue&type=script&lang=js"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=676a7f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a7f44",
  null
  
)

export default component.exports